import { KeyValue } from "@angular/common";
import { UdeuLoan } from "./udeu-loan";
import { UdeuCreateFile, UdeuFile } from "./udeu-files";
import { UdeuBoud } from "./udeu-boud";

export class UdeuCreateRecord {
    data: UdeuRecord;
    files: UdeuCreateFile[];
}

export class UdeuEditMassiveRecord {
    UUIDs: string[];
    data: UdeuRecord;
    addFields: string[];
    deleteFields: string[];

    constructor(UUIDs: string[]) {
        this.UUIDs = UUIDs;
    }
}

export class UdeuRecord {
    id: string;
    name: string;
    draft: boolean;
    classification: UdeuClassification;
    data: UdeuData;
    authors: UdeuAuthor[];
    info: UdeuInfo;
    context: UdeuContext;
    files: UdeuFile[];
    locations: UdeuLocation[];
    loans: UdeuLoan[];
    bouds: UdeuBoud[];
}

export class UdeuClassification {
    fund: string | KeyValue<string, string>;
    classificationGroup: string | KeyValue<string, string>;
    classification: string | KeyValue<string, string>;
    division: string | KeyValue<string, string>;
    subdivision: string | KeyValue<string, string>;
    specificSubdivision: string | KeyValue<string, string>;
    nominalSubdivision: string[] | KeyValue<string, string>[];
}

export class UdeuData {
    category: string | KeyValue<string, string>;
    typology: string | KeyValue<string, string>;
    title: string | KeyValue<string, string>;
    depositProv: string | KeyValue<string, string>;
    descLevel: string | KeyValue<string, string>;
    startDate: string;
    endDate: string;
    supportVolume: string | KeyValue<string, string>;
}

export class UdeuAuthor {
    id: string;
    gaudeId: string;
    ria: string;
    name: string;
    lastname1: string;
    lastname2: string;
}

export class UdeuInfo {
    scopeContent: string;
    descriptors: string[] | KeyValue<string, string>[];
    thesaurus: string[] | KeyValue<string, string>[];
}

export class UdeuContext {
    valuation: string | KeyValue<string, string>;
    location: string;
    access: string | KeyValue<string, string>;
    reproduction: string;
    notes: string;
    language: string;
    conservation: string;
    associatedDocuments: string;
}

export class UdeuLocation {
    id?: string;
    deposit: string | KeyValue<string, string>;
    installationUnit: string;
    document?: string;
    signaturaDocE?: string;
    signatura?: string;
}